import type { Token } from "@ext/markdown/core/render/logic/Markdoc";
import type MarkdownIt from "markdown-it";

/** `| Элемент {width=180px} |`: the column width is markup in the header cell, read off into an attribute. */

const WIDTH = /\s*\{width=(\d+)px\}\s*$/;

const readWidth = (value: string) => {
	const width = Number(value);
	return Number.isSafeInteger(width) && width > 0 ? String(width) : null;
};

const readColumnWidths = (tokens: Token[]) => {
	let inHeader = false;
	let cell: Token = null;

	for (const token of tokens) {
		if (token.type === "thead_open") inHeader = true;
		else if (token.type === "thead_close") inHeader = false;

		if (!inHeader) continue;

		if (token.type === "th_open" || token.type === "td_open") {
			cell = token;
			continue;
		}

		if (token.type !== "inline" || !cell) continue;

		// The marker is the tail of the text of the cell. An image states its own size right
		// after the link, and that `{width=}` belongs to the picture, not to the column.
		const text = token.children?.at(-1);
		const marker = text?.type === "text" ? WIDTH.exec(text.content) : null;
		const width = marker && readWidth(marker[1]);

		if (width) {
			cell.attrSet("colwidth", width);
			text.content = text.content.replace(WIDTH, "");
			token.content = token.content.replace(WIDTH, "");
		}
		cell = null;
	}
};

const tableWidthPlugin = (md: MarkdownIt) => {
	md.core.ruler.push("table-column-width", (state) => readColumnWidths(state.tokens as Token[]));
};

export default tableWidthPlugin;
